/* eslint-disable no-case-declarations */
import Vue from 'vue'
import { cloneDeep } from 'lodash'

import { sortCases } from '@/utilities'

import { CloneLegalCaseMutations } from './partials/clone'
import { ClosingWizardMutations } from './partials/closing-wizard'
import { DocketEntriesInfoMutations } from './partials/docket-entries-info'
import { DocketEntriesMutations } from './partials/docket-entries'
import { ECOPortalIntegrationMutations } from './partials/eco-portal-integration'
import { EngagementLetterMutations } from './partials/engagement-letter'
import { LegalCaseEditMutations } from './partials/edit'
import { LegalCaseTagMutations } from './partials/tag'
import { ReopeningWizardMutations } from './partials/reopening-wizard'

export const LegalCaseMutations = {
  ...CloneLegalCaseMutations,
  ...ClosingWizardMutations,
  ...DocketEntriesMutations,
  ...DocketEntriesInfoMutations,
  ...ECOPortalIntegrationMutations,
  ...EngagementLetterMutations,
  ...LegalCaseEditMutations,
  ...LegalCaseTagMutations,
  ...ReopeningWizardMutations,

  removeLegalCase (state, value) {
    const index = state.legalCases.findIndex(c => c.id === Number(value.id))
    if (index > -1) state.legalCases.splice(index, 1)
  },

  setCurrentLegalCaseTitle: (state, value) => {
    state.legalCase.title = value
  },

  setLegalCaseAssociatedParties: (state, value) => {
    state.legalCase.parties = value
    if (!state.legalCase.id) return

    const lc = state.legalCases.find(lc => lc.id === state.legalCase.id)
    if (!lc) return

    lc.parties = cloneDeep(value)
  },

  setLegalCaseId: (state, value) => {
    state.legalCase.id = value
  },

  setLegalCaseUnassociatedParties: (state, value) => {
    state.legalCaseUnassociatedParties = value
  },

  setPaginationOptions: (state, value) => {
    state.paginationOptions = value
  },

  setSearchLoading: (state, value) => {
    state.isSearching = value
  },

  setShowAssociatePartyDialog: (state, value) => {
    state.showAssociatePartyDialog = value
  },

  setCurrentLegalCase (state, value) {
    state.currentLegalCase = value
  },

  setCurrentLegalCaseId (state, value) {
    state.currentLegalCaseId = isNaN(value) ? undefined : Number(value)
  },

  setLegalCase (state, value) {
    if (Array.isArray(value)) {
      state.legalCases = value
      state.legalCase = {}
    } else {
      const match = state.legalCases.findIndex(c => c.id === Number(value.id))
      const index = match >= 0 ? match : state.legalCases.length
      const previousData = state.legalCases[index] || {}

      // Merge response with our stored state
      const legalCase = {
        ...previousData,
        ...value,
      }
      state.legalCase = value
      // Use vue set when updating an array element to make it reactive
      Vue.set(state.legalCases, index, legalCase)
    }

    // Sort cases, show open cases first, then sort by opened date
    state.legalCases.sort(sortCases)
  },

  setLegalCaseOptionsList (state, value) {
    state.legalCaseOptionsList = value
  },

  setLegalCasesPartySliderSettings (state, value) {
    state.partySliderSettings = value
  },

  // This mutations replaces or adds a Legal Case to the Legal Cases list
  // without setting the Legal Case object (used as the Current Legal Case in
  // the Legal Case View)
  storeLegalCase (state, value) {
    let idx = state.legalCases.findIndex(lc => lc.id === Number(value.id))
    if (idx < 0) idx = state.legalCases.length
    Vue.set(state.legalCases, idx, value)
  },

  updateLegalCaseParty (state, party) {
    state.legalCases.forEach(lc => {
      const idx = lc.parties.findIndex(p => p.id === party.id)
      if (idx >= 0) Vue.set(lc.parties, idx, party)
    })

    const idx = state.legalCase.parties.findIndex(p => p.id === party.id)
    if (idx < 0) return
    Vue.set(state.legalCase.parties, idx, party)
  },
}
